import { ICompany } from 'app/shared/model/company.model';
import { VehicleTypeEnum } from 'app/shared/model/enumerations/vehicle-type-enum.model';
import { CategoryVehicleModel } from './enumerations/category-vehicle-model.model';
import { SubcategoryVehicleModel } from './enumerations/subcategory-vehicle-model';
import { TireFunction } from 'app/shared/model/enumerations/tire-function.model';

export interface IVehicleModel {
  id?: number;
  name?: string | null;
  type?: VehicleTypeEnum | null;
  description?: string | null;
  imageContentType?: string | null;
  image?: string | null;
  objectKey?: string | null;
  company?: ICompany | null;
  category?: CategoryVehicleModel | null;
  subcategory?: SubcategoryVehicleModel | null;
  tireFunction?: Record<number, TireFunction> | null;
}

export const defaultValue: Readonly<IVehicleModel> = {};
